import api from './api';

/**
 * Servicio de certificación por insignia cd-2b (docs/120 F5/F5b/F8) para el consultor. Mismo
 * estilo que `cd2bPropuestaService.js`/`cd2bReventaService.js` (llamadas directas a `api`).
 * Rutas verificadas contra `api/src/routes/cd2bCertificacionRoutes.js` (`/v1/cd2b`).
 *
 * MODO DEMO solo cubre las lecturas (`misInsignias`/`examenes`) — ver `cd2bReventaService.js`.
 * Presentar un examen de verdad (`iniciarIntento`/`entregarIntento`) siempre va contra el backend
 * real, con o sin modo demo activo: simular ahí calificaciones ficticias sería más confuso que útil.
 *
 * OJO con `entregarIntento`: NO hay un `PUT .../respuestas` para ir guardando a medio camino — el
 * backend solo tiene `iniciarIntento` (sirve el banco) y `entregarIntento` (califica TODO de una
 * vez). La UI del examen debe acumular las respuestas en memoria y mandarlas juntas al entregar.
 */
const cd2bCertificacionService = {
  /** Insignias emitidas al asesor (vigente/por vencer/vencida, una por track). */
  async misInsignias() {
    const response = await api.get('/cd2b/certificacion/mis-insignias');
    return response.data;
  },
  /**
   * Exámenes activos con intentos/enfriamiento/prerequisitos y (F5b) el progreso EN VIVO del
   * curso de Academy vinculado (`cursoRecomendado`), sin correctas/explicacion de ninguna pregunta.
   */
  async examenes() {
    const response = await api.get('/cd2b/certificacion/examenes');
    return response.data;
  },
  /** Arranca un intento nuevo: banco sorteado, opciones barajadas, `expiraAt` fijado por el servidor. */
  async iniciarIntento(codigo) {
    const response = await api.post(`/cd2b/certificacion/examenes/${codigo}/intentos`);
    return response.data;
  },
  /** Entrega y califica el intento. `respuestas`: [{ preguntaId, seleccion:[Number] }] (posiciones SERVIDAS). */
  async entregarIntento(intentoId, respuestas) {
    const response = await api.post(`/cd2b/certificacion/intentos/${intentoId}/entregar`, { respuestas });
    return response.data;
  },
  /** Verificación PÚBLICA de una credencial por slug — sin auth (para compartir con el cliente). */
  async verificarCredencial(slug) {
    const response = await api.get(`/cd2b/certificacion/verificar/${slug}`);
    return response.data;
  },
};

export default cd2bCertificacionService;
